import notifyUser from './notifyUser';
import { NOTIFICATION_STATUS, OYO360_OTPSIGNUP_VIEW, OYOOS_LOGIN_PAGE } from '../constants';
import defaultTranslations from '../Translations/en.json';

const redirectToLogin = store => {
  notifyUser({
    store,
    id: 'failedCreateContract',
    status: NOTIFICATION_STATUS.ERROR,
    toast_text: defaultTranslations.SESSION_EXPIRED,
    timer: 2000,
  });
  if (process.env.REACT_APP_PLATFORM === 'OYO360') {
    window.location.href = OYO360_OTPSIGNUP_VIEW;
  } else {
    window.location.href = OYOOS_LOGIN_PAGE;
  }
};

export default redirectToLogin;
